import _tagged_template_literal from "@swc/helpers/src/_tagged_template_literal.mjs";
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  margin-right: 0;\n  padding: 4px 3px 3px;\n  ",
        " {\n    padding: 7px 6px 6px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import React from "react";
import styled from "styled-components";
// import Text from "../Text/Text";
// import Dropdown from "../Dropdown/Dropdown";
import Button from "../Button/Button";
import LanguageIcon from "../Svg/Icons/Language";
import LanguageCurrencyIcon from "../Svg/Icons/LanguageCurrency";
var LangWrapper = styled.div.withConfig({
    componentId: "sc-6d18d92a-0"
})(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.sm;
});
var LangSelector = function(param) {
    var currentLang = param.currentLang, langs = param.langs, color = param.color, setLang = param.setLang, _dropdownPosition = param.dropdownPosition, dropdownPosition = _dropdownPosition === void 0 ? "bottom" : _dropdownPosition, _buttonScale = param.buttonScale, buttonScale = _buttonScale === void 0 ? "md" : _buttonScale, _hideLanguage = param.hideLanguage, hideLanguage = _hideLanguage === void 0 ? false : _hideLanguage, isMobile = param.isMobile;
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: /*#__PURE__*/ _jsx(Button, {
            scale: buttonScale,
            variant: "text",
            style: {
                height: "auto",
                padding: isMobile ? "0px" : "0 8px"
            },
            onClick: function() {
                var lang = langs.filter(function(v) {
                    return v.code !== currentLang;
                })[0];
                // console.log("currentLang", currentLang, lang)
                window.localStorage.removeItem("isShowPopup");
                setLang(lang);
            },
            children: /*#__PURE__*/ _jsx(LangWrapper, {
                children: currentLang === "en" ? /*#__PURE__*/ _jsx(LanguageIcon, {
                    width: buttonScale === "xs" ? "32px" : "32px"
                }) : /*#__PURE__*/ _jsx(LanguageCurrencyIcon, {
                    width: buttonScale === "xs" ? "32px" : "32px"
                })
            })
        })
    });
};
export default /*#__PURE__*/ React.memo(LangSelector, function(prev, next) {
    return prev.currentLang === next.currentLang;
});
